import BorderCardList from 'src/component/common/layout/BorderCardList';
import BorderTableCard from 'src/component/screen/bordertable/BorderTableCard';

export function BorderTableScreen(): JSX.Element {
  return <BorderCardList card={BorderTableCard} />;
}
